import { ActionEnum } from '../actions/types/orderActions.types';

const ELIGIBLE_ACTIONS: ActionEnum[] = [
  ActionEnum.FINISH_TO_IN_REVISION,
  ActionEnum.FINISH_TO_ON_APPROVAL,
];

export const isActionEligibleForSatisfactionSurvey = (action: ActionEnum): boolean =>
  ELIGIBLE_ACTIONS.includes(action);
